import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ROUTE_PATH } from '../../../../config/paths';

const CloneRouteButton = ({ routeId }) => (
  <Link className="btn btn-info" to={`${ROUTE_PATH}/${routeId}/clone`}>
    <i className="fa fa-clone" /> Clonar
  </Link>
);

CloneRouteButton.propTypes = {
  routeId: PropTypes.number.isRequired,
};

export default CloneRouteButton;
